import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { GA4SearchEvent, GtmEventType, GtmSearchEvent } from './gtmEventType';

export class GtmSearchType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_SEARCH_DONE && event.searchContext?.type === 'keyword';
    }

    // @ts-expect-error * Automated Type Error Fix
    getBody(event): GA4SearchEvent {
        const { queryText, totals } = event.searchContext;

        return {
            event: 'custEv_search',
            search_term: queryText,
            search_type: 'site',
            search_category: 'all',
            search_result_count: (totals?.apps || 0) + (totals?.consultants || 0),
            app_results: totals?.apps,
            consultant_results: totals?.consultants,
        };
    }
}
